import JSZip from 'jszip'
import { getToken} from '@/api/liveShop'
import * as qiniu from 'qiniu-js'

export function createzip(imgs){
  return new Promise((resolve,reject)=>{
    exportZip(imgs,resolve)
  })
}
async function getUrlBase64(url, ext) {
  console.log(url)
  return new Promise((resolve, reject) => {
    var canvas = document.createElement('canvas') // 创建canvas DOM元素
    var ctx = canvas.getContext('2d')
    var img = new Image()
    img.crossOrigin = 'Anonymous' // 处理跨域
    img.src = url+'?imageView2/0/w/800'
    img.onload = () => {
      canvas.width = img.width // 指定画板的高度,自定义
      canvas.height = img.height // 指定画板的宽度，自定义
      ctx.drawImage(img, 0, 0) // 参数可自定义
      var dataURL = canvas.toDataURL('image/' + ext)
      console.log(dataURL)
      resolve(dataURL) // 回调函数获取Base64编码
      canvas = null
    }
  })
}
async function exportZip(imgs,resolve) {
    const imgList = imgs
    const proList = []
    const zip = new JSZip()
    const cache = {}
    await imgList.forEach((item) => {
      // 等待所有图片转换完成
      let suffix=item.split('.').pop()
      console.log(suffix)
      const pro =getUrlBase64(item, '.'+suffix).then((base64) => {
        const fileName = item.replace(/(.*\/)*([^.]+)/i, '$2')
        zip.file(fileName, base64.substring(base64.indexOf(',') + 1), {
          base64: true,
        })
        cache[fileName] = base64
      })
      proList.push(pro)
    })
    Promise.all(proList).then((res) => {
      zip
        .generateAsync({
          type: 'blob',
        })
        .then((content) => {
          return upload(content,resolve)
        })
  })
}

function upload(content,resolve) {
  getToken().then((res) => {
    let uptoken = res.data.token
    let config = {
      useCdnDomain: false, // 表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
      region: null, // 根据具体提示修改上传地区,当为 null 或 undefined 时，自动分析上传域名区域
    }
    let putExtra = {
      fname: '', // 文件原文件名
      params: {}, // 用来放置自定义变量
      mimeType:null, // 用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
    }
    const observable = qiniu.upload(
      content,
      'zaiart/saas/imageZip/' + new Date().getTime() + '.zip',
      uptoken,
      putExtra,
      config
    )
    observable.subscribe({
      next: (result) => {
        // console.log(result)
      },
      error: (errResult) => {
        console.log(errResult)
      },
      complete: (result) => {
        return resolve('https://img.zai-art.com/' + result.key)
      },
    })
  })
}